import { gql } from '@apollo/client';
import { Location } from 'history';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { useInternalGraphLinking } from '../../hooks/useInternalGraphLinking';

export const getLinkToWorkflowFragment = gql`
  fragment getLinkToWorkflowFragment on CheckWorkflow {
    id
    baseVariant {
      id
      name
    }
  }
`;

export function getLinkToWorkflow(
  workflow: GraphQLTypes.getLinkToWorkflowFragment,
  location: Location,
  internalGraphLinking: ReturnType<typeof useInternalGraphLinking>,
) {
  return internalGraphLinking.currentCheckSchemasRoute.locationFrom({
    location,
    fromRouteConfig: internalGraphLinking.currentVariantRouteConfig,
    patch: {
      ...(internalGraphLinking.isProposalRoute
        ? {}
        : { graphVariant: workflow.baseVariant?.name }),
      checkId: workflow.id,
    },
  });
}
